<template>
    <nav class="flex flex-wrap items-center justify-start p-4 bg-white border-b border-gray-200 lg:justify-between">
        <div class="flex items-center flex-shrink-0 text-white">
            <svg class="w-8 h-8 mr-2 fill-current" width="54" height="54" viewBox="0 0 250 250" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.60001 126.2c2.6-6.8 5.79999-13 9.69999-18.5 11.5 23.8 30.2 43.6 54.3 54.8 24.3 11.4 50.2 12.3 73.7 4.6-.2 1.5-.5 3.7-.8 6-.9 5.1-2.3 10.1-4.2 15.1-15.4 40.8-57.6 60.1-94.2 42.9C8.49998 214-8.79999 167 6.60001 126.2z"
                    fill="#1a202c"
                />
                <path
                    d="M177.9 38.7999c3.5 6.3 6 12.9 7.8 19.6-24.1-3.5-49.4 1.9-71.7 17.1C91.5 90.8999 75.7 113.7 67.6 139.5c-1-1.1-2.4-2.7-3.9-4.2-3.2-3.8-6-8-8.6-12.6C34.3 84.8999 45 35.5999 78.9 12.3999c33.9-23.2 78.2-11.399984 99 26.4z"
                    fill="#1a202c"
                />
                <path
                    d="M160.8 82.9999c-6.6.3-12.9 1.6-18.9 3.7C157.9 107 168.1 133.4 169.2 162.5c1.1 29.4-7.1 56.7-21.7 78.6 1.3.3 3.3.8 5.3 1.2 4.6.8 9.3 1.1 14.2.9 39.7-1.9 70.6-39.3 68.9-83.5-1.8-44.3-35.4-78.6001-75.1-76.7001z"
                    fill="#1a202c"
                />
            </svg>
            <span class="hidden font-semibold tracking-tight text-gray-900 lg:block">Get started with Flowist</span>
        </div>
        <div class="flex flex-col items-start leading-tight lg:hidden">
            <div class="font-semibold text-gray-800">Create account</div>
            <div v-if="this.$route.name === 'account'" class="text-xs text-gray-700">
                Step 1 of 3
            </div>
            <div v-else-if="this.$route.name === 'confirm'" class="text-xs text-gray-700">
                Step 2 of 3
            </div>
            <div v-else class="text-xs text-gray-700">Step 3 of 3</div>
        </div>
        <div class="flex items-center hidden w-full lg:flex lg:items-center lg:w-auto lg:block">
            <div class="mr-6 text-lg text-grey-900" :class="{ selected: this.$route.name === 'account' }">
                1. Create account
            </div>
            <div class="mr-6 text-lg text-grey-900" :class="{ selected: this.$route.name === 'confirm' }">
                2. Confirm your email
            </div>
            <div class="text-lg text-grey-900" :class="{ selected: this.$route.name === 'checkout' }">
                3. Start now!
            </div>
        </div>
        <div class="flex items-center hidden text-sm lg:block">
            <span class="text-gray-600">
                Already using Flowist?
            </span>
            <router-link tag="a" class="font-bold text-gray-600 underline" to="/signin">
                Sign in
            </router-link>
        </div>
    </nav>
</template>
<script>
export default {
    name: 'signup-header',
    data() {
        return {
            name: 'james',
        };
    },
};
</script>
<style scoped>
.selected {
    @apply font-bold;
}
</style>
